import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <div className="page-header">
        <div className="container">
          <h1>Privacy Policy</h1>
        </div>
      </div>

      <div className="privacy-content">
        <div className="container">
          <div className="legal-content">
            <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>

            <section>
              <h2>1. Introduction</h2>
              <p>
                Doctors Lab ("we," "our," or "us") is committed to protecting your privacy and the 
                confidentiality of your personal health information. This Privacy Policy explains how 
                we collect, use, disclose, and safeguard your information when you visit our website 
                and use our services.
              </p>
            </section>

            <section>
              <h2>2. Health Information Privacy (HIPAA)</h2>
              <p>
                As a clinical laboratory, Doctors Lab is subject to the Health Insurance Portability 
                and Accountability Act (HIPAA) and other applicable federal and state laws regarding 
                the privacy and security of protected health information (PHI). We maintain strict 
                confidentiality of all health information in accordance with these laws.
              </p>
            </section>

            <section>
              <h2>3. Information We Collect</h2>
              <p>We may collect the following types of information:</p>
              <ul>
                <li><strong>Personal Information:</strong> Name, address, phone number, email address, date of birth</li>
                <li><strong>Health Information:</strong> Medical history, test results, diagnoses, and other health-related information</li>
                <li><strong>Payment Information:</strong> Billing and payment information</li>
                <li><strong>Website Usage Information:</strong> IP address, browser type, pages visited, and other usage data</li>
              </ul>
            </section>

            <section>
              <h2>4. How We Use Your Information</h2>
              <p>We use your information to:</p>
              <ul>
                <li>Provide laboratory testing services</li>
                <li>Process and deliver test results</li>
                <li>Communicate with you about your tests and services</li>
                <li>Process payments and billing</li>
                <li>Comply with legal and regulatory requirements</li>
                <li>Improve our services and website</li>
              </ul>
            </section>

            <section>
              <h2>5. Disclosure of Information</h2>
              <p>
                We may disclose your health information to:
              </p>
              <ul>
                <li>Your healthcare providers who ordered the tests</li>
                <li>Authorized individuals you have designated</li>
                <li>Insurance companies for billing purposes</li>
                <li>Public health authorities as required by law</li>
                <li>Law enforcement when required by law or court order</li>
              </ul>
              <p>
                We do not sell your personal or health information to third parties.
              </p>
            </section>

            <section>
              <h2>6. Security Measures</h2>
              <p>
                We implement appropriate technical and administrative safeguards to protect your 
                information against unauthorized access, alteration, disclosure, or destruction. 
                These measures include encryption, secure servers, access controls, and regular 
                security assessments.
              </p>
            </section>

            <section>
              <h2>7. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access your health information</li>
                <li>Request corrections to your information</li>
                <li>Request restrictions on how we use or disclose your information</li>
                <li>Request confidential communications</li>
                <li>Receive an accounting of disclosures</li>
                <li>File a complaint if you believe your privacy rights have been violated</li>
              </ul>
            </section>

            <section>
              <h2>8. Cookies and Tracking Technologies</h2>
              <p>
                Our website may use cookies and similar tracking technologies to enhance your 
                experience. You can set your browser to refuse cookies, but this may limit some 
                website functionality.
              </p>
            </section>

            <section>
              <h2>9. Third-Party Links</h2>
              <p>
                Our website may contain links to third-party websites. We are not responsible for 
                the privacy practices of these external sites. We encourage you to review the 
                privacy policies of any third-party sites you visit.
              </p>
            </section>

            <section>
              <h2>10. Children's Privacy</h2>
              <p>
                Our services are not directed to individuals under the age of 18. We do not 
                knowingly collect personal information from children without appropriate parental 
                consent.
              </p>
            </section>

            <section>
              <h2>11. Changes to This Privacy Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any 
                material changes by posting the new policy on this page and updating the "Last 
                Updated" date.
              </p>
            </section>

            <section>
              <h2>12. Contact Us</h2>
              <p>
                If you have questions or concerns about this Privacy Policy or our privacy practices, 
                please contact us at:
              </p>
              <p>
                Doctors Lab<br />
                Email: <a href="mailto:info@drslab.com">info@drslab.com</a><br />
                Phone: (123) 456-7890
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;

